/**
 * Allocation domain types (risk profile enum, etc.).
 *
 * Belongs here: shared allocation types.
 * Does not belong here: UI.
 */
export enum AllocationRiskProfile {
  CONSERVATIVE = 'CONSERVATIVE',
  BALANCED = 'BALANCED',
  AGGRESSIVE = 'AGGRESSIVE',
  VERY_AGGRESSIVE = 'VERY_AGGRESSIVE'
}
